module.exports = __webpack_public_path__ + "img/facebook-icon.814ae53c.svg";